import { deletePetOwner } from "../../api/petOwnerService";

export const useDeletePetOwner = (setPetOwners) => {
    const remove = async (id) => {
        try {
        await deletePetOwner(id);
            // update local state by filtering out the deleted company
            setPetOwners((prev) => prev.filter((c) => c.id !== id));
        } catch (error) {
            console.error("Failed to delete pet owner:", error);
            throw error;
        }
    };

    return { remove };
};